import { type FC } from "react";
import { Button, Stack, TableCell } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotesIcon from "@mui/icons-material/Notes";

interface Props {
  onOpenNotes: () => void;
  onOpenStats: () => void;
}

const ClientRowActions: FC<Props> = ({ onOpenNotes, onOpenStats }) => (
  <TableCell align="right" sx={{ minWidth: 120 }}>
    <Stack spacing={0.25} sx={{ alignItems: "flex-end" }}>
      <Button size="small" startIcon={<NotesIcon />} onClick={onOpenNotes} sx={{ justifyContent: "flex-start" }}>
        Notatki
      </Button>
      <Button size="small" startIcon={<BarChartIcon />} onClick={onOpenStats} sx={{ justifyContent: "flex-start" }}>
        Statystyka
      </Button>
    </Stack>
  </TableCell>
);

export default ClientRowActions;
